import React, {useState, useEffect, Fragment} from 'react';
import {Spinner} from "react-bootstrap";
import moment from "moment";
import {UE_STAMP_IMG} from "../../constants";

import TemplatePROHeader from "./templates/BASE/TemplatePROHeader";
import Template1BCadastral from "./templates/BASE/Template1BCadastral";
import Template1BLocalisation from "./templates/BASE/Template1BLocalisation";
import Template1BSynthese from "./templates/BASE/Template1BSynthese";
import Template1BUrba2 from "./templates/BASE/Template1BUrba2";
import Template1BRisque from "./templates/BASE/Template1BRisque";
import Template1BPrescription from "./templates/BASE/Template1BPrescription";
import Template1BServitude from "./templates/BASE/Template1BServitude";
import Template1BObservation from "./templates/BASE/Template1BObservation";
import Template1BAgriculture from "./templates/BASE/Template1BAgriculture";
import Template1BEnvironnement from "./templates/BASE/Template1BEnvironnement";
import Template1BPatrimoine from "./templates/BASE/Template1BPatrimoine";
import Template1BNuisanceSonore from "./templates/BASE/Template1BNuisanceSonore";

import Color from "color";
import Template1BPreemption from "./templates/BASE/Template1BPreemption";
import TemplateDPUSynthese from "./templates/DPU/TemplateDPUSynthese";
import TemplateDPUAdresse from "./templates/DPU/TemplateDPUAdresse";


const DPUForm = (props) => {

    const [isLoading, setIsLoading] = useState(false)
    const [displayForm, setDisplayForm] = useState("dpu")
    const [primaryCol, setPrimaryCol] = useState(Color("#0f444a"))

    useEffect((e)=>{
        setDisplayForm("level1")
    }, [])

    return (
        (isLoading)
            ?<div className="text-center my-2"><Spinner animation="border" size={'sm'}/></div>
            :<div className={'yui3-cssreset ue-container'} id={"eu-data"}>
                <TemplatePROHeader />
                <div className="ue-section ue-form-title" style={{"backgroundColor": primaryCol.hex()}}>
                    <span>DROIT DE PRÉEMPTION</span>
                </div>
                <Template1BCadastral primColor={primaryCol}/>
                <TemplateDPUAdresse primColor={primaryCol} addressBien={props.addressBien}/>
                <Template1BLocalisation screenCapt={props.screenCapt}/>
                <TemplateDPUSynthese formtype={displayForm} primColor={primaryCol}/>
                <div className="page-break"></div>
                <Template1BPreemption formtype={displayForm} primColor={primaryCol}/>
                <p>
                    Une commune ayant instaurée un droit de préemption peut décider de renoncer à l'achat dans un délai de 2 mois à partir de la réception de la DIA. Dans ce cas, la renonciation est définitive.
                    Le propriétaire peut alors vendre son bien à l'acheteur de son choix. L'absence de réponse durant un délai de 2 mois à partir de la réception de la DIA équivaut à un refus de préempter.
                </p>
                <br/>
                <br/>
                <p style={{"fontWeight": "700", "marginBottom":"0.4rem"}}>Acceptation sans réserve</p>
                <p>
                    La commune peut décider d'acheter le bien aux conditions proposées par le propriétaire. Les parties signent alors un acte authentique concluant la vente.
                    La commune a 4 mois à partir de la signature de l'acte pour régler le paiement.
                    Tant que la commune n'a pas intégralement réglé le paiement, l'ancien propriétaire conserve la jouissance du bien.
                </p>
                <br/>
                <br/>
                <p style={{"fontWeight": "700", "marginBottom":"0.4rem"}}>Acceptation avec réserve</p>
                <p>
                    La commune peut décider de renégocier le prix de vente. Dans ce cas, elle a 2 mois à partir de la réception de la DIA pour proposer un autre prix au propriétaire par lettre recommandée avec avis de réception.Le propriétaire a alors 2 mois à partir de l'offre de la commune pour lui notifier soit qu'il accepte le prix proposé par elle, soit qu'il maintient sa 1re offre, soit qu'il renonce à la vente. En l'absence d'accord sur le prix, les parties peuvent saisir le tribunal.Si le tribunal est saisi par la commune, celle-ci doit bloquer 15 % du prix de vente à la Caisse des dépôts et consignations (CDC).
                    Cette somme est bloquée jusqu'au transfert du bien ou jusqu'au moment où la commune renonce à son droit de préemption. La CDC en informe le propriétaire par lettre recommandée avec avis de réception. Les parties ont 2 mois à partir de la décision du tribunal pour faire connaître leur réponse. Le silence des parties vaut acceptation du prix et transfert du bien.Un acte authentique concluant la vente doit être réalisé dans un délai de 3 mois. La commune a 4 mois à partir de la signature de l'acte pour régler le paiement de la vente.
                    Tant que la commune n'a pas intégralement réglé le paiement, l'ancien propriétaire conserve la jouissance.
                </p>

                <div className={"ue-stamp-sign-zone"} style={{"pageBreakInside":"avoid"}}>
                    <div className=" ue-tempon-zone">
                        <div className="ue-dat-valid"><i>Fait à Ajaccio le {moment().format('DD/MM/YYYY')}</i></div>
                        <img src={UE_STAMP_IMG} alt="tempon urbaearth"  style={{"height": "110px"}}/>
                    </div>

                    <div className="text-left ue-foot-note" >
                        <p><i>
                            La présente note d’urbanisme fait état des renseignements fondés sur les documents en vigueur connus à ce jour sous réserve d’un Certificat
                            d’Urbanisme, un permis ou une autorisation susceptible de modifier les renseignements fournis (L410-1 et L442-14 du code de l’urbanisme). Elle
                            constitue un simple document d’information et ne peut en aucun cas être considérée comme une autorisation administrative quelconque, ni un certificat
                            d’urbanisme. Elle renseigne sur la zone où est situé l’immeuble mais n’a pas pour objet de déterminer la constructibilité ou la non constructibilité.
                        </i>
                        </p>
                    </div>
                </div>
            </div>
    );
};


export default DPUForm;
